import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setShowNavbar, setShowFriends } from "../stores/uiState/UiStateSlice";

function PrivacyPolicy() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setShowNavbar(true));
    dispatch(setShowFriends(false));
  }, []);

  return (
    <section className="LegalPage">
      <div className="legalContainer">
        <h1 className="legalTitle">Privacy Policy</h1>
        <p className="legalDate">Last updated: March 28, 2026</p>

        <div className="legalContent">
          <h2>1. Introduction</h2>
          <p>
            Welcome to Drafter (&quot;we&quot;, &quot;our&quot;, or
            &quot;us&quot;). We operate the website drafter.one (the
            &quot;Service&quot;). This Privacy Policy explains how we collect,
            use, and protect your personal information when you use our Service.
          </p>

          <h2>2. Information We Collect</h2>
          <h3>Account Information</h3>
          <p>
            When you sign in with Google, we receive your Google account name
            and email address. This information is used to create and manage
            your Drafter account.
          </p>
          <h3>Game Data</h3>
          <p>
            We collect data related to your gameplay, including your draft
            choices, game results, Elo rating, and match history. This data is
            used to provide the game experience, maintain leaderboards, and
            improve our services.
          </p>
          <h3>Usage Data</h3>
          <p>
            We automatically collect certain information when you visit our
            Service, including your browser type, pages visited, and time spent
            on the site. We use Google Analytics to understand how users
            interact with our Service.
          </p>

          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide and maintain the Service</li>
            <li>Manage your account and game progress</li>
            <li>Display leaderboards and player profiles</li>
            <li>Analyze usage patterns to improve the Service</li>
            <li>Display relevant advertisements through Google AdSense</li>
            <li>Prevent abuse and enforce our terms</li>
          </ul>

          <h2>4. Advertising</h2>
          <p>
            We use Google AdSense to display advertisements on our Service.
            Google AdSense may use cookies and similar technologies to serve ads
            based on your prior visits to our website or other websites. You can
            opt out of personalized advertising by visiting{" "}
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google Ads Settings
            </a>
            .
          </p>

          <h2>5. Cookies</h2>
          <p>
            We use cookies and similar tracking technologies to maintain your
            session, remember your preferences, and serve advertisements. You
            can control cookies through your browser settings.
          </p>

          <h2>6. Data Sharing</h2>
          <p>
            We do not sell your personal information. We may share data with:
          </p>
          <ul>
            <li>
              <strong>Google</strong> — for authentication (Firebase Auth),
              analytics (Google Analytics), and advertising (Google AdSense)
            </li>
            <li>
              <strong>Other players</strong> — your username, Elo rating, and
              game history are visible on your public profile and the
              leaderboard
            </li>
          </ul>

          <h2>7. Data Security</h2>
          <p>
            We use Firebase and Google Cloud Platform to store and protect your
            data. While we implement industry-standard security measures, no
            method of transmission over the Internet is 100% secure.
          </p>

          <h2>8. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and associated data</li>
            <li>Opt out of personalized advertising</li>
          </ul>
          <p>
            To exercise these rights, please contact us at the email address
            below.
          </p>

          <h2>9. Children&apos;s Privacy</h2>
          <p>
            Our Service is not directed to children under 13. We do not
            knowingly collect personal information from children under 13. If
            you believe we have collected such information, please contact us.
          </p>

          <h2>10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify
            you of any changes by posting the new policy on this page and
            updating the &quot;Last updated&quot; date.
          </p>

          <h2>11. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact
            us at: <a href="mailto:contact@drafter.one">contact@drafter.one</a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
